import React from 'react';

import { Box, Chip, SxProps, Theme, Typography } from '@mui/material';

type RoadmapPeriodBadgeProps = Readonly<{
  /** Text inside the inner pill, e.g. 'June'. */
  label: string;
  /** Text alongside the pill, e.g. 'Junior Year'. */
  caption?: string;
}>;

/** Brand pill holding a second pill, used above a guide section to mark its point in time. */
export const RoadmapPeriodBadge: React.FC<RoadmapPeriodBadgeProps> = ({ label, caption }) => (
  <Box sx={containerSx}>
    <Chip label={label} variant="pill" size="sm" sx={chipSx} />
    {caption && (
      <Typography variant="text-sm-medium" sx={captionSx}>
        {caption}
      </Typography>
    )}
  </Box>
);

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  alignSelf: 'flex-start',
  gap: backrs.spacing['spacing-md'],
  pl: backrs.spacing['spacing-xs'],
  pr: backrs.spacing['spacing-lg'],
  py: backrs.spacing['spacing-xs'],
  borderRadius: backrs.radius['radius-full'],
  border: `1.5px solid ${backrs.colors['Brand/600']}`,
  backgroundColor: backrs.colors['Brand/50'],
});

const chipSx: SxProps<Theme> = ({ backrs }) => ({
  height: 'auto',
  px: backrs.spacing['spacing-md'],
  py: backrs.spacing['spacing-xxs'],
  border: `1.5px solid ${backrs.colors['Brand/600']}`,
  backgroundColor: backrs.colors['Colors/Base/White'],
  color: backrs.colors['Colors/Text/text-brand-primary'],
});

const captionSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-brand-primary'],
});
